export default __webpack_public_path__ + "static/media/k.69f24ace.png";